import type { StoreApi } from 'zustand'
import type { createSetPasswordActions } from '../domain/setPasswordActions'
import * as React from 'react'
import { SetPasswordStore } from '@/scopes/auth/domain/types'

interface SetPasswordDependencies {
  actions?: ReturnType<typeof createSetPasswordActions>
  store?: StoreApi<SetPasswordStore>
}

const defaultDependencies: SetPasswordDependencies = {}

const SetPasswordDependenciesContext = React.createContext<SetPasswordDependencies>(defaultDependencies)

export function SetPasswordDependenciesProvider({
  children,
  dependencies = defaultDependencies,
}: React.PropsWithChildren<{ dependencies?: SetPasswordDependencies }>) {
  return (
    <SetPasswordDependenciesContext value={dependencies}>
      {children}
    </SetPasswordDependenciesContext>
  )
}

export function useSetPasswordDependencies() {
  return React.use(SetPasswordDependenciesContext)
}

export function useSetPasswordActions() {
  const { actions } = useSetPasswordDependencies()
  if (!actions) {
    throw new Error('actions not provided')
  }
  return actions
}
